<template>
    <div class="header-row">

        <div class="languages">
            <LanguageSwitch />
        </div>
        <div class="user-items">
            <div class="centred">
                <UserGreeting />
            </div>
            <div class="centred">
                <ShortcutsInfo />
            </div>
            <div class="centred">
                <LogOut />
            </div>
        </div>
    </div>
    <NewUserPrompt />
    <NewDesignPrompt />


</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import LanguageSwitch from './LanguageSwitch.vue'
    import UserGreeting from './UserGreeting.vue'
    import ShortcutsInfo from './ShortcutsInfo.vue'
    import LogOut from './LogOut.vue'
    import NewUserPrompt from '@/features/UserTour/NewUserPrompt.vue'
    import NewDesignPrompt from './NewDesignPrompt.vue'


    export default defineComponent({
        components: {
            LanguageSwitch,
            ShortcutsInfo,
            UserGreeting,
            LogOut,
            NewUserPrompt,
            NewDesignPrompt,
        },
    })
</script>

<style lang="scss" scoped>

    .header-row {
        display: flex;
        justify-content: space-between;
    }

    .user-items {
        display: flex;
        font-size: 17px;
    }

    .centred {
        display: flex;
        align-items: center;
    }

</style>